
<h1 mat-dialog-title>{{ 'case_widget.dialog.settings.title' | translate | titlecase }}</h1>

<div mat-dialog-content>

    <div class="widget-settings-group" *ngIf="!isLoading">

        <div class="row mb-2" *ngFor="let filterGroup of tableMetaData.filterGroups;">
            <div class="col-6">
                <mat-form-field class="full-width">
                    <mat-label>{{ 'case_widget.settings.filter.'+ filterGroup.id +'.label' | translate }}</mat-label>
                    <mat-select id="{{idPrefix}}{{filterGroup.id}}"
                                [(ngModel)]="widgetSettings.filters[filterGroup.id]">
                        <mat-option *ngFor="let filter of filterGroup.filters"
                                    id="{{idPrefix}}{{filterGroup.id}}.{{filter.id}}"
                                    [value]="filter.id">
                            {{ (filter.displayName != filter.id ? filter.displayName : 'case_widget.settings.filter.'+filterGroup.id+'.option.'+filter.id) | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>    
            </div>
        </div>

        <div class="row mb-2">
            <div class="col-12">
                <div class="form-group">
                    <label>{{ 'case_widget.settings.displayedColumns' | translate }}</label>
                
                    <drag-n-drop-chips [(bananaBox)]="curentSelectedColumns"
                                    [selectionList]="filteredAvailableColumns"
                                    [selectionListLabel]="'case_widget.settings.displayedColumns' | translate"
                                    [idPrefix]="(idPrefix + 'columns.')"
                                    (bananaBoxChange)="filterAvailableColumns()">
                    </drag-n-drop-chips>
                </div>
            </div>
        </div>

        <div class="row mb-4">
            <div class="col-4">
                <mat-form-field class="full-width">
                    <mat-label>{{ 'case_widget.settings.linesPerPage' | translate }}</mat-label>
                    <mat-select id="{{idPrefix}}lines_per_page"
                                [(ngModel)]="widgetSettings.linesPerPage">
                        <mat-option *ngFor="let line of [5, 10, 15, 20]"
                                    id="{{idPrefix}}lines_per_page.amount_{{line}}"
                                    [value]="line">
                            {{ line }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

    </div>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6">
        <button mat-stroked-button
                color="primary"
                id="create_case_dialog.btn.cancel"
                class="full-width"
                (click)="close()">
            {{ 'common.btn.cancel' | translate }}
        </button>
    </div>

    <div class="col-sm-6 no-gutters pl-0">
        <button id="{{idPrefix}}btn.ok"
                mat-raised-button class="full-width" color="accent"
                (click)="accept()">
            {{ 'common.btn.ok' | translate }}
        </button>
    </div>

</div>
